// @ts-nocheck
export const selectAuthenticated = state => state.auth.authenticated;
export const selectAuthenticating = state => state.auth.authenticating;
export const selectCurrentUser = state => state.auth.currentUser;
